import React from 'react';
import { connect } from 'react-redux';
import UserQrCode from './UserQrCode';
import { updateHeader, updateFavModel } from '../../../actions/local';
import { postFavorite, fetchScannedAttendees } from '../../../actions/api';
import { selectUser } from '../../../selectors/user';
import { selectMenuItems } from '../../../selectors/menuItems';
import { selectScannedAttendeesIds } from '../../../selectors/scannedAttendees';
import { selectCanTakeNotes } from '../../../selectors/scanNotesPermissions';
import Mixpanel from '../../../Mixpanel';
class UserQrCodeContainer extends React.Component {
  componentDidMount() {
    const { appId, eventId } = this.props.match.params;
    this.props.updateHeader({
      leftBtn: window.history.length > 1 ? 'back' : 'nav',
      rightBtn: null,
      rightBtn2: null
    });

    this.props.fetchScannedAttendees({ 
      reset: true,
      app_id: +appId,
      event_id: +eventId
    });

    document.addEventListener('deviceready', this.onDeviceReady, false);

    Mixpanel.track('view', {
      viewableType: 'user-qrcode',
      viewableId: null,
      appId: +appId,
      eventId: +eventId,
      userId: this.props.user ? this.props.user.id : null
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.eventId !== prevProps.match.params.eventId) {
      const { appId, eventId } = this.props.match.params;
      this.props.fetchScannedAttendees({ 
        reset: true,
        app_id: +appId,
        event_id: +eventId
      });
    }
  }

  componentWillUnmount() {
    if (
      window.cordova &&
      window.cordova.plugins &&
      window.cordova.plugins.brightness &&
      this.originalBrightness
    ) {
      let brightness = window.cordova.plugins.brightness;
      brightness.setBrightness(this.originalBrightness);
      brightness.setKeepScreenOn(false);
    }
    document.removeEventListener('deviceready', this.onDeviceReady);
  }

  onDeviceReady = () => {
    if (window.cordova && window.cordova.plugins && window.cordova.plugins.brightness) {
      let brightness = window.cordova.plugins.brightness;
      brightness.getBrightness(originalBrightness => {
        this.originalBrightness = originalBrightness;
      });

      // value should be float in range from 0 to 1.
      brightness.setBrightness(1);
      brightness.setKeepScreenOn(true);
    }
  };

  render() {
    if (!this.props.user) {
      return null;
    }
    const { t, theme, history, user, menuItems, postFavorite, updateFavModel, scannedAttendeesIds, canTakeNotes } = this.props;
    const matchParams = this.props.match.params;
    return <UserQrCode {...{ t, theme, history, matchParams, user, menuItems, postFavorite, updateFavModel, scannedAttendeesIds, canTakeNotes }} />;
  }
}

const mapDispatchToProps = {
  updateHeader: updateHeader,
  postFavorite: postFavorite,
  updateFavModel: updateFavModel,
  fetchScannedAttendees: fetchScannedAttendees
};

const mapStateToProps = (state, ownProps) => {
  return {
    user: selectUser(state, ownProps),
    menuItems: selectMenuItems(state, ownProps),
    scannedAttendeesIds: selectScannedAttendeesIds(state, ownProps),
    canTakeNotes: selectCanTakeNotes(state, ownProps)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserQrCodeContainer);
